var IconButton    = require("app/ui/IconButton"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    kind          = require("enyo/kind");

require("app/theme/IconButton--header.less");

module.exports = kind(/** @lends  app.AppHeader.AddToHomeScreenButton.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.AddToHomeScreenButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-app-header-add-to-home-screen-button",

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "header",

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: null,

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @private
     */
    handlers: {
        onclick: "onClick"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);

            // Update content
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.installPromptService.canPrompt", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            isLoggedIn  = this.app.$.authService.isLoggedIn,
            canPrompt   = this.app.$.installPromptService.canPrompt;

        this.set("caption", i18nService.getString("app.AppHeader.AddToHomeScreenButton.caption"));
        this.set("tooltip", i18nService.getString("app.AppHeader.AddToHomeScreenButton.tooltip"));
        this.set("showing", canPrompt && isLoggedIn === 1);
    },

    /**
     * Add an event listener to show the deferred installPrompt on click.
     *
     * Chrome only allows displaying the deferred prompt from inside the handler
     * of the click event. Any degree of indirection and it does not work.
     * Therefore, we *must* add the listener explicitly instead of relying on
     * Enyo's event handling.
     *
     * @private
     */
    rendered: kind.inherit(function(sup) {
        return function() {
            var node,
                clickHandler;

            sup.apply(this, arguments);

            node         = this.hasNode();
            clickHandler = this.app.$.installPromptService.showInstallPrompt;
            node         && node.addEventListener("click", clickHandler);
        };
    }),

    /**
     * Since we added our own eventListener on render, we also need to remove it
     * again.
     *
     * @private
     */
    beforeTeardown: kind.inherit(function(sup) {
        return function() {
            var node,
                clickHandler;

            sup.apply(this, arguments);

            node         = this.hasNode();
            clickHandler = this.app.$.installPromptService.showInstallPrompt;
            node         && node.removeEventListener("click", clickHandler);
        };
    })

});
